import React from 'react';
import './loaders.css';

const CircularLoader = ({ height, width }) => {
  return (
    <div
      style={{
        width: width || '2em',
        height: height || '2em',
      }}
      className="edgify-circular-loader-container"
    />
  );
};

export default CircularLoader;
